
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import {
  Task, BoxOutcomeType, ProjectsPool, Lead,
} from '@/types';

@Component
export default class TaskOutcomeBox extends Vue {
  @Prop(String) readonly value!: BoxOutcomeType | null;
  @Prop(Object) readonly task!: Task;
  @Prop(String) readonly name!: string;
  @Prop({ type: Boolean, default: false }) readonly readonly!: boolean;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Boolean, default: false }) readonly useFather!: boolean

  boxOutcome: BoxOutcomeType = 'todo';

  created() {
    console.log('TaskOutcomeBox: created()'); // eslint-disable-line no-console

    if (this.value === null) {
      this.boxOutcome = 'todo';
    } else {
      this.boxOutcome = this.value;
    }
  }

  @Watch('value')
  onValue(val: BoxOutcomeType) {
    console.log('TaskOutcomeBox: onValue()'); // eslint-disable-line no-console

    this.boxOutcome = val;
  }

  get pool(): ProjectsPool {
    return this.$store.getters.currentPool;
  }

  get childLead(): Lead | null {
    return this.task.relationship === 'father'
      && this.task.childLeadId
      && this.task.childLeadId in this.pool
      ? this.pool[this.task.childLeadId]
      : null;
  }

  get lead(): Lead {
    if (this.useFather && this.father) {
      return this.father;
    }

    return this.childLead ?? this.$store.getters.currentLead;
  }

  get father(): Lead | null {
    if (!this.task || 'fatherLeadId' in this.task === false) return null;
    const fatherLeadId = this.task.relationship === 'child'
      ? this.task.fatherLeadId : this.task.LeadId;

    return fatherLeadId && fatherLeadId in this.pool
      ? this.pool[fatherLeadId]
      : null;
  }

  get boxColor(): string {
    switch (this.boxOutcome) {
      case 'todo':
        return 'grey';

      case 'success':
        return 'success';

      case 'fail':
        return 'error';

      case 'warning':
        return 'orange';

      default:
        break;
    }

    return '';
  }

  get boxDark(): boolean {
    if (this.disabled) return false;

    switch (this.boxOutcome) {
      case 'todo':
        return true;

      case 'success':
        return true;

      case 'fail':
        return true;

      case 'warning':
        return true;

      default:
        break;
    }

    return true;
  }

  get boxOutlined(): boolean {
    switch (this.boxOutcome) {
      case 'todo':
      case 'success':
      case 'fail':
      case 'warning':
        return false;

      default:
        break;
    }

    return false;
  }

  get boxText(): string {
    switch (this.boxOutcome) {
      case 'todo':
        return 'Da fare';

      case 'success':
        return 'Positivo';

      case 'fail':
        return 'Negativo';

      case 'warning':
        return 'Adeguamenti necessari';

      default:
        break;
    }

    return 'Non disponibile';
  }

  async setBoxOutcome(outcome: BoxOutcomeType) {
    if (this.boxOutcome === outcome) {
      console.log(`TaskOutcomeBox: setBoxOutcome() outcome = ${outcome} (non modificato, ignorato)`); // eslint-disable-line no-console
      return;
    }

    console.log('TaskOutcomeBox: setBoxOutcome() outcome =', outcome); // eslint-disable-line no-console

    this.boxOutcome = outcome;

    this.$emit('update', outcome);
  }
}
